import React, { useState } from 'react';
import RootModal from '../../../common/RootModal';
import Button from '../../../common/Button';
import CustomInput from '../../../common/CustomInput';

const ConfirmInsurancePopup = ({ 
  isOpen, 
  onClose, 
  onProceed, 
  patientName 
}) => {
  const [selectedOption, setSelectedOption] = useState('');

  // Options for the dropdown
  const insuranceOptions = [
    { 
      label: 'Update Insurance Information', 
      value: 'update_insurance' 
    },
    { 
      label: 'Consents to Pay for Clinical Service', 
      value: 'consent_to_pay' 
    },
    { 
      label: 'Does NOT consent to pay for Clinical Service', 
      value: 'does_not_consent' 
    }
  ];

  const handleProceed = () => {
    if (selectedOption && selectedOption !== '') {
      onProceed(selectedOption);
    }
  };

  // Get button text based on selected option
  const getButtonText = () => {
    switch (selectedOption) {
      case 'consent_to_pay':
        return 'Update & Save';
      case 'does_not_consent':
        return 'End Clinical Service';
      case 'update_insurance':
        return 'Update & Save';
      default:
        return 'Update & Save';
    }
  };

  const handleDropdownChange = (option) => {
    setSelectedOption(option.value);
  };

  return (
    <RootModal
      open={isOpen}
      handleClose={onClose}
      title="Confirm Insurance Information"
      titleClassName="text-body-xl font-semibold text-teal-300"
      className="max-w-[580px]"
    >
      <div className="flex flex-col gap-6 px-6">
        <p className="text-gray-700">
          This patient has <span className="font-bold text-teal-300">No Provincial Insurance</span> on file. <br/> How would you like to proceed?
        </p>

        {/* CustomInput Dropdown */}
        <CustomInput
          options={insuranceOptions}
          name="insurance_option"
          type="dropdown"
          placeholder=" Insurance or Payment Option"
          value={selectedOption}
          onChange={handleDropdownChange}
          shortMenuHeight={true}
        />
      </div>

      {/* Buttons */}
      <div className="px-6 pb-6">
        <div className="flex justify-center gap-4">
          <Button
            type="secondary"
            text="Cancel"
            onClick={onClose}
            className="w-[280px]"
          />
          <Button
            type="primary"
            text={getButtonText()}
            onClick={handleProceed}
            className="w-[280px]"
            disabled={!selectedOption || selectedOption === ''}
          />
        </div>
      </div>
    </RootModal>
  );
};

export default ConfirmInsurancePopup;